/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStoreAction } from 'state/commonActions';

import { DocumentData } from 'components/render-page/pages/summary-page/document/affordable-document/types';

export interface AffordableDocumentState {
  documents: DocumentData;
  isLoading: boolean;
  error: string | null;
  isAffordableDocumentSigned: boolean;
}

const initialState: AffordableDocumentState = {
  documents: {},
  isLoading: false,
  error: null,
  isAffordableDocumentSigned: true,
};

const affordableDocumentSlice = createSlice({
  name: 'affordableDocument',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setDocuments: (state, action: PayloadAction<DocumentData>) => {
      state.documents = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setIsAffordableDocumentSigned: (state, action: PayloadAction<boolean>) => {
      state.isAffordableDocumentSigned = action.payload;
    },
    resetDocuments: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreAction, () => initialState);
  },
});

export const { setLoading, setDocuments, setError, setIsAffordableDocumentSigned, resetDocuments } =
  affordableDocumentSlice.actions;

export default affordableDocumentSlice.reducer;
